import { UseMutationResult, useMutation } from "@tanstack/react-query";

import {
    UpdatedRiskDirectoryStructure,
    RiskDirectoryResource,
} from "api/generated/model";
import { putRisksRiskDirectoryIdStructure } from "api/generated/risks/risks";

const RISK_DIRECTORY_STRUCTURE_MUTATION =
    "update-risk-directory-structure-mutation";

export function useRiskDirectoryStructureMutation(
    riskDirectoryId: number
): UseMutationResult<
    RiskDirectoryResource,
    Error,
    UpdatedRiskDirectoryStructure
> {
    return useMutation({
        mutationKey: [RISK_DIRECTORY_STRUCTURE_MUTATION, riskDirectoryId],
        mutationFn: async (data: UpdatedRiskDirectoryStructure) => {
            const response = await putRisksRiskDirectoryIdStructure(
                riskDirectoryId,
                data
            );
            return response.data;
        },
    });
}
